import { AbstractReportPmsApiService } from '../abstract-report.service';
import { RoomMoveReport } from "../../../models/reports/daily-activity/room-move.model";

/**
 * @class RoomMoveReportPmsApiService
 * @extends {AbstractReportPmsApiService<RoomMoveReport>}
 */
export class RoomMoveReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/daily-activity/room-move';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {RoomMoveReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new RoomMoveReport(attributes);
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/reports/daily-activity/room-move.service.js